// test2668
(2668 && 0);
